import React, { useEffect } from 'react';
import Icon from '../AppIcon'; // Adjust path if needed

const Modal = ({ isOpen, onClose, title, children, footer = null, maxWidth = 'max-w-md', compactHeader = false }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-in fade-in duration-200"
      onClick={handleBackdropClick}
    >
      <div 
        className={`bg-card border border-border rounded-2xl shadow-2xl w-full ${maxWidth} max-h-[90vh] overflow-hidden flex flex-col animate-in zoom-in-95 duration-200`}
      >
        {/* Modal Header */}
        <div className={`flex items-center justify-between border-b border-border bg-muted/30 ${compactHeader ? 'px-4 py-3 sm:px-6' : 'p-4 md:p-6'}`}>
          <h2 className="font-heading font-bold text-xl text-foreground">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground hover:bg-muted p-1 rounded-md transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Modal Body */}
        <div className="flex-1 overflow-y-auto p-4 md:p-6 custom-scrollbar">
          {children}
        </div>

        {footer && (
          <div className="flex-shrink-0 border-t border-border bg-card p-4 md:px-6">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
